import { ROUTE_STYLES, BALL_STYLES } from "@/lib/playStyles";

function Sample({ color, dash, end }) {
  return (
    <svg width="44" height="16" viewBox="0 0 44 16" aria-hidden="true">
      <line x1="2" y1="8" x2={end === "tee" ? 38 : 34} y2="8" stroke={color} strokeWidth="3" strokeDasharray={dash ? dash.split(" ").map((v) => v * 6).join(" ") : undefined} />
      {end === "tee" && <line x1="38" y1="2" x2="38" y2="14" stroke={color} strokeWidth="3" />}
      {end === "arrow" && <path d="M33,2 L43,8 L33,14 z" fill={color} />}
    </svg>
  );
}

const ITEMS = [
  { ...ROUTE_STYLES.run, end: "arrow" },
  { ...ROUTE_STYLES.block },
  { ...ROUTE_STYLES.motion },
  { label: "Pass (ball in the air)", color: BALL_STYLES.pass.color, dash: BALL_STYLES.pass.dash, end: "arrow" },
  { label: "Snap / Handoff / Pitch", color: "#FACC15", dash: "0.5 0.5", end: "arrow" },
];

export function Legend({ className = "" }) {
  return (
    <div className={`flex flex-wrap gap-x-4 gap-y-2 text-xs text-slate-300 ${className}`} data-testid="route-legend">
      {ITEMS.map((it) => (
        <span key={it.label} className="inline-flex items-center gap-1.5"><Sample {...it} />{it.label}</span>
      ))}
      <span className="inline-flex items-center gap-1.5"><span className="inline-block w-4 h-4 rounded-full bg-[#FF6B00] border-2 border-white" />Offense: circle, team color</span>
      <span className="inline-flex items-center gap-1.5"><span className="inline-block w-3.5 h-3.5 rotate-45 bg-slate-600 border-2 border-white" />Defense: diamond, gray</span>
    </div>
  );
}
